// ?===============================
// ?=====  3rd party Imports  =====
// ?===============================

import React from 'react'
import { Link } from 'gatsby-link'
import { NavLink } from '@theme-ui/components'
import slugify from 'slugify'

// ?===================================
// ?====  Local Function Imports  =====
// ?===================================
import checkIfExternalLink from '../../../../../helpers/checkIfExternalLink'
import multiLocationLink from '../../../../../helpers/multiLocationLink'
import useCurrentLocationNameAndSlug from '../../../../../hooks/useCurrentLocationNameAndSlug'

export default function NavLinkSelector({
  ctaName,
  className,
  variant,
  ctaLink,
  isMultiLocationSite,
  // city,
  page,
  pageObjectKey
}) {
  const { currentLocationSlug } = useCurrentLocationNameAndSlug()

  const ctaLinkSelectorExternal = () => {
    if (ctaLink === 'none') {
      return (
        <a className={className ? className : ''} target="_blank" rel="noreferrer">
          {ctaName}
        </a>
      )
    } else {
      return (
        <a href={ctaLink} className={className ? className : ''} target="_blank" rel="noreferrer">
          {ctaName}
        </a>
      )
    }
  }

  const ctaLinkSelectorInternal = () => {
    if (ctaLink === 'none') {
      return (
        <a className={className ? className : ''} target="_blank" rel="noreferrer">
          {ctaName}
        </a>
      )
    } else {
      return (
        <Link to={isMultiLocationSite ? multiLocationLink(currentLocationSlug, ctaLink) : `/${ctaLink}`}>
          {ctaName}
        </Link>
      )
    }
  }

  return (
    <NavLink
      as="li"
      className={`
    navItem
    ${slugify(ctaName, { lower: true })}
    ${className ? className : ''} ${pageObjectKey === ctaLink ? 'navItemActive' : ''}`}
      variant={`${variant}.navItem`}
    >
      {checkIfExternalLink(page.ctaLink) ? ctaLinkSelectorExternal() : ctaLinkSelectorInternal()}
    </NavLink>
  )
}
